import React, { useMemo } from 'react';
import type { WixHelpWidgetInitParams } from '@wix/wix-help-widget/types';
import { WixHelpWidget } from '@wix/wix-help-widget';
import * as util from '#packages/util';
import type { HelpWidgetDispatchProps } from './helpWidgetMappers';
import { mapDispatchToProps } from './helpWidgetMappers';

const {
  connect,
  STORES: { EDITOR_API },
} = util.hoc;

export interface HelpWidgetOwnProps {}

interface HelpWidgetProps extends HelpWidgetDispatchProps, HelpWidgetOwnProps {}

const HelpWidget: React.FunctionComponent<HelpWidgetProps> = ({
  children,
  openNewReleasesFeed,
  startWelcomeTour,
}) => {
  const initParams = useMemo<WixHelpWidgetInitParams>(
    () => ({
      origin: 'Editor',
      isInvokedFromHeader: true,
      editorCallbacks: {
        tourTheEditorCallback: () => {
          startWelcomeTour();
        },
        newReleasesCallback: () => {
          openNewReleasesFeed();
        },
      },
    }),
    [startWelcomeTour, openNewReleasesFeed],
  );

  return <WixHelpWidget initParams={initParams}>{children}</WixHelpWidget>;
};

export default connect(EDITOR_API, undefined, mapDispatchToProps)(HelpWidget);
